
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import GoogleAnalytics from '../components/GoogleAnalytics';



function Xcenthyundaionrentinpune() {



  const cardData =
  {
    keyword: 'Xcent Hyundai On Rent in Pune',
    heading: 'SHREE Tours & Travels: Xcent Hyundai On Rent in Pune',
    headingDescription: 'SHREE Tours & Travels offers Hyundai Xcent on rent in Pune, providing a comfortable and budget-friendly travel option for local and outstation trips. Whether you need a one-way Cab, round trip, airport transfer, or business travel, our well-maintained Hyundai Xcent ensures a smooth and hassle-free journey. With professional drivers, on-time service and affordable fares, we guarantee a safe and enjoyable ride. Choose SHREE Tours & Travels for the best Hyundai Xcent rental service in Pune.',

    top: 'Top Places to Visit in Pune with SHREE Tours & Travels',

"topPlaces": [
    {
        "title": "Shaniwar Wada",
        "description": "A historic fortification in Pune, Shaniwar Wada was once the seat of the Peshwas of the Maratha Empire. Built in 1732, this grand structure features intricate wooden architecture, massive gates and the famous 'Delhi Darwaza.' It is surrounded by gardens and fountains, making it a great spot for history enthusiasts. The light and sound show in the evening narrates the fort's rich history, adding to the experience."
    },
    {
        "title": "Aga Khan Palace",
        "description": "Built in 1892, the Aga Khan Palace is an architectural masterpiece and a symbol of India's freedom struggle. It served as a prison for Mahatma Gandhi and other freedom fighters during the Quit India Movement. The palace features Italian arches, sprawling gardens and a museum housing personal belongings of Mahatma Gandhi, making it a must-visit for history and heritage lovers."
    },
    {
        "title": "Sinhagad Fort",
        "description": "Perched atop a hill, Sinhagad Fort is one of Pune’s most famous trekking destinations. This historic fortress, associated with the Maratha warrior Tanaji Malusare, offers breathtaking views of the Sahyadri mountains. Visitors can explore the ancient ruins, enjoy local delicacies like 'pithla bhakri,' and experience the fort’s rich history while trekking through its scenic trails."
    },
    {
        "title": "Dagdusheth Halwai Ganpati Temple",
        "description": "One of Pune’s most revered temples, Dagdusheth Halwai Ganpati Temple is dedicated to Lord Ganesha. Known for its grand Ganesh idol adorned with gold ornaments, the temple attracts thousands of devotees daily. The temple’s annual Ganesh festival is a grand spectacle, featuring magnificent decorations, cultural performances and a spiritual ambiance."
    },
    {
        "title": "Raja Dinkar Kelkar Museum",
        "description": "A fascinating museum housing over 20,000 artifacts, the Raja Dinkar Kelkar Museum showcases a diverse collection of sculptures, paintings, musical instruments and everyday objects from India’s past. The museum is particularly known for its replica of the Mastani Mahal, which provides a glimpse into the royal lifestyle of the Peshwas."
    },
    {
        "title": "Pataleshwar Cave Temple",
        "description": "Carved out of a single rock in the 8th century, the Pataleshwar Cave Temple is dedicated to Lord Shiva. This ancient temple, featuring massive stone pillars and intricate carvings, is a peaceful retreat amidst Pune’s bustling city life. The temple’s unique architecture and serene atmosphere make it a hidden gem for history and spirituality seekers."
    },
    {
        "title": "Pashan Lake",
        "description": "Pashan Lake is a beautiful artificial lake, ideal for nature lovers and bird watchers. Surrounded by lush greenery, the lake serves as a habitat for various migratory birds. The walking track along the lake makes it a perfect spot for morning walks, photography and peaceful relaxation away from the city’s hustle."
    },
    {
        "title": "Osho Ashram",
        "description": "Located in Koregaon Park, the Osho International Meditation Resort is a world-renowned spiritual center promoting meditation and wellness. Visitors can experience a range of meditation techniques, yoga sessions and rejuvenation therapies. The ashram's lush gardens, serene atmosphere and international community make it a unique place for self-discovery and relaxation."
    },
    {
        "title": "Lal Mahal",
        "description": "Lal Mahal is a historic site closely associated with Chhatrapati Shivaji Maharaj, as it was his childhood residence. Though rebuilt, the palace features paintings and exhibits depicting Shivaji’s life and achievements. The site is of great historical importance and offers insights into the Maratha legacy."
    },
    {
        "title": "Khadakwasla Dam",
        "description": "Situated on the outskirts of Pune, Khadakwasla Dam is a popular picnic spot offering scenic views and a refreshing escape. The dam is a great place for photography, evening walks and enjoying street food like corn and chai. The nearby Sinhagad Fort and Panshet Dam make it a perfect getaway for adventure seekers and nature lovers."
    }
],  
    
            
"services": [
    {
      "name": "Xcent Hyundai Car Rental Pune",
      "description": "Rent a Hyundai Xcent in Pune for a comfortable and affordable ride. Our car rental services ensure a smooth journey, whether you're traveling for leisure, business, or any other purpose."
    },
    {
      "name": "Rent Hyundai Xcent in Pune",
      "description": "Looking for a Hyundai Xcent in Pune? Book this compact sedan for city rides, outstation trips, or airport transfers. With a comfortable interior and efficient fuel economy, it's a great choice for all your travel needs."
    },
    {
      "name": "Affordable Xcent Hyundai Rental Pune",
      "description": "Get affordable Hyundai Xcent rental services in Pune without compromising on quality. Enjoy a stylish, reliable and fuel-efficient car for your daily travel, road trips and events."
    },
    {
      "name": "Hyundai Xcent Taxi Hire Pune",
      "description": "Hire a Hyundai Xcent taxi in Pune for a comfortable and affordable ride. Whether you're traveling locally or heading out of town, our taxis offer you a smooth and convenient travel experience."
    },
    {
      "name": "Xcent for Outstation Travel in Pune",
      "description": "Plan your outstation trip from Pune with a Hyundai Xcent. Our rental service ensures a comfortable, efficient and economical journey to nearby cities and tourist spots."
    },
    {
      "name": "Xcent Hyundai Car Hire for City Tour",
      "description": "Book a Hyundai Xcent for a city tour in Pune. With its spacious interior and excellent fuel economy, it's perfect for sightseeing around Pune's attractions, whether you're solo or with a group."
    },
    {
      "name": "Xcent on Rent for Airport Drop Pune",
      "description": "Rent a Hyundai Xcent for your airport drop in Pune. We offer timely and comfortable rides, ensuring a stress-free journey to and from Pune Airport for both domestic and international flights."
    },
    {
      "name": "Hyundai Xcent for Family Travel Pune",
      "description": "Travel with your family in comfort by renting a Hyundai Xcent in Pune. This compact sedan provides ample space, smooth rides and a pleasant experience for families on vacation or visiting friends."
    },
    {
      "name": "Book Xcent Hyundai for Business Travel",
      "description": "Rent a Hyundai Xcent for your business trips in Pune. With a professional driver and a well-maintained vehicle, it's the ideal choice for corporate meetings, events and conferences."
    },
    {
      "name": "Hyundai Xcent Rental for Group Travel",
      "description": "Traveling with a group? Rent a Hyundai Xcent for your group travel needs in Pune. With enough space to accommodate small groups, this car ensures a comfortable journey whether you're on a business or leisure trip."
    },
    {
      "name": "Rent Xcent Hyundai for Local Pune Travel",
      "description": "Rent a Hyundai Xcent for local travel in Pune. Whether you're commuting to work, visiting family, or exploring the city, enjoy a smooth and comfortable ride in this stylish car."
    },
    {
      "name": "Xcent Hyundai Hire for Corporate Events Pune",
      "description": "Book a Hyundai Xcent for corporate events in Pune. With a focus on punctuality, professionalism and comfort, our car hire services ensure you arrive on time and in style at your business meetings or corporate gatherings."
    }
  ],
  "tableData": [
    ["- Xcent Hyundai Car Rental Pune", "- Rent Hyundai Xcent in Pune"],
    ["- Affordable Xcent Hyundai Rental Pune", "- Hyundai Xcent Taxi Hire Pune"],
    ["- Xcent for Outstation Travel in Pune", "- Xcent Hyundai Car Hire for City Tour"],
    ["- Xcent on Rent for Airport Drop Pune", "- Hyundai Xcent for Family Travel Pune"],
    ["- Book Xcent Hyundai for Business Travel", "- Hyundai Xcent Rental for Group Travel"],
    ["- Rent Xcent Hyundai for Local Pune Travel", "- Xcent Hyundai Hire for Corporate Events Pune"]
  ],


  
  whychoose: [
    {
      "WhyChooseheading": "Comfortable and Spacious Ride",
      "WhyChoosedescription": "The Hyundai Xcent offers a comfortable and spacious ride, making it an ideal choice for both short and long journeys in Pune. With ample legroom, modern amenities and smooth handling, the Xcent ensures a pleasant travel experience for you and your passengers."
    },
    {
      "WhyChooseheading": "Affordable Rental Options",
      "WhyChoosedescription": "We offer competitive and affordable rates for renting the Hyundai Xcent in Pune. Whether you need the car for a day or a longer period, our rental packages are designed to provide the best value without compromising on quality and comfort."
    },
    {
      "WhyChooseheading": "Well-Maintained Vehicles",
      "WhyChoosedescription": "All our Hyundai Xcent cars are regularly serviced and maintained to ensure optimal performance, safety and cleanliness. Each vehicle undergoes routine checks to guarantee that it is in excellent condition for your ride, offering both reliability and comfort."
    },
    {
      "WhyChooseheading": "Experienced and Professional Drivers",
      "WhyChoosedescription": "Our drivers are highly experienced and professional, ensuring a safe and comfortable journey. They are familiar with the best routes in Pune and their focus on customer satisfaction ensures that your ride is smooth, timely and pleasant."
    },
    {
      "WhyChooseheading": "Perfect for Business and Leisure Travel",
      "WhyChoosedescription": "The Hyundai Xcent is the perfect choice for both business and leisure travel. Whether you're heading to a business meeting, an event, or simply exploring Pune, the Xcent provides a perfect balance of comfort, style and practicality for all types of travel."
    },
    {
      "WhyChooseheading": "Simple and Quick Booking Process",
      "WhyChoosedescription": "Booking the Hyundai Xcent with SHREE Tours & Travels is easy and fast. You can book online through our user-friendly platform or contact our customer service team for personalized assistance. We ensure that the booking process is quick and hassle-free."
    },
    {
      "WhyChooseheading": "24/7 Availability",
      "WhyChoosedescription": "Our Hyundai Xcent rental service in Pune is available 24/7. Whether you need the car early in the morning or late at night, we offer flexible booking options to ensure you get a car whenever you need it, no matter the time of day."
    },
    {
      "WhyChooseheading": "Customer Satisfaction Guarantee",
      "WhyChoosedescription": "Customer satisfaction is our priority. We aim to provide the best service for every Hyundai Xcent rental in Pune. With our focus on comfort, safety and punctuality, we guarantee a smooth and enjoyable experience that will exceed your expectations."
    }
  ]
  
  
  
  

  
  



        
  }
  const faqData = [
    {
        question: "How can I rent an Xcent Hyundai in Pune?",
        answer: "You can easily rent an Xcent Hyundai in Pune through our website or by contacting our customer service for assistance."
    },
    {
        question: "What is the rental rate for an Xcent Hyundai in Pune?",
        answer: "The rental rate for the Xcent Hyundai varies depending on the duration and type of trip. For detailed pricing information, please contact us."
    },
    {
        question: "Is the rental rate for the Xcent Hyundai inclusive of fuel?",
        answer: "Fuel charges may vary depending on the rental agreement. We provide detailed pricing information during the booking process."
    },
    {
        question: "Can I rent an Xcent Hyundai for a one-way trip in Pune?",
        answer: "Yes, we offer one-way rental options for the Xcent Hyundai for trips within Pune and nearby cities."
    },
    {
        question: "Do you provide drivers with the Xcent Hyundai on rent in Pune?",
        answer: "Yes, all our Xcent Hyundai rentals come with experienced drivers who are familiar with the local routes to ensure a safe and comfortable journey."
    },
    {
        question: "What is your cancellation policy for Xcent Hyundai bookings in Pune?",
        answer: "We offer a flexible cancellation policy. Please contact us for detailed information specific to your booking."
    },
    {
        question: "What payment methods do you accept for renting an Xcent Hyundai in Pune?",
        answer: "We accept various payment methods, including cash, credit/debit cards and mobile wallets for your convenience."
    },
    {
        question: "Are the Xcent Hyundai vehicles insured for safety during trips in Pune?",
        answer: "Yes, all our Xcent Hyundai vehicles are fully insured for your safety and peace of mind during the journey."
    },
    {
        question: "Can I request a child seat for my Xcent Hyundai rental in Pune?",
        answer: "Yes, child seats can be arranged upon request at the time of booking."
    },
    {
        question: "What is your contact information for renting an Xcent Hyundai in Pune?",
        answer: "For bookings and inquiries, you can reach us at: +91 9594917913."
    }
];

const testimonialsData = [
    {
        text: 'I rented an Xcent Hyundai from SHREE Tours & Travels for a day trip in Pune. The car was well-maintained and the driver was courteous and professional.',
        name: 'Mr. Vijay Sharma',
    },
    {
        text: 'The Xcent Hyundai rental service from SHREE Tours & Travels was excellent. The vehicle was clean, comfortable and the entire booking process was smooth.',
        name: 'Miss. Anjali Deshmukh',
    }
];















  
  
  


  


  const contactData = {
     heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 9594917913",

    ],
    email: "booking@shreecabs24.com"
  };


    const Images = [
    {
        place: "/images/keyword/1.jpg",
        text: "Pune to Kolhapur Cab",
        link: "/Pune-to-Kolhapur-Cab",
    },
    {
        place: "/images/keyword/2.jpg",
        text: "Pune to Mumbai Cab",
        link: "/Pune-to-Mumbai-Cab",
    },
    {
        place: "/images/keyword/3.jpg",
        text: "Pune to Sangli Cab",
        link: "/Pune-to-Sangli-Cab",
    },
    {
        place: "/images/keyword/4.jpg",
        text: "Pune to Mahabaleshwar Cab",
        link: "/Pune-to-Mahabaleshwar-Cab",
    },
    {
        place: "/images/keyword/5.jpg",
        text: "Pune to Bhimashankar Cab",
        link: "/Pune-to-Bhimashankar-Cab",
    },
    {
        place: "/images/keyword/6.jpg",
        text: "Pune to Shirdi Cab",
        link: "/Pune-to-Shirdi-Cab",
    },
    {
        place: "/images/keyword/7.jpg",
        text: "Pune to Nashik Cab",
        link: "/Pune-to-Nashik-Cab",
    },
    {
        place: "/images/keyword/8.jpg",
        text: "Pune Airport Pickup and Drop",
        link: "/Pune-Airport-Pickup-and-Drop",
    },
    {
        place: "/images/keyword/9.jpg",
        text: "Pune To Mumbai Airport Cab",
        link: "/Pune-To-Mumbai-Airport-Cab",
    },
    {
        place: "/images/keyword/10.jpg",
        text: "Mumbai To Pune Cab",
        link: "/Mumbai-To-Pune-Cab",
    },
    {
        place: "/images/keyword/12.jpg",
        text: "Mumbai To Kolhapur Cab",
        link: "/Mumbai-To-Kolhapur-Cab",
    },
    {
        place: "/images/keyword/13.jpg",
        text: "Mumbai To Shirdi Cab",
        link: "/Mumbai-To-Shirdi-Cab",
    },
    {
        place: "/images/keyword/14.jpg",
        text: "Mumbai To Nashik Cab",
        link: "/Mumbai-To-Nashik-Cab",
    },
    {
        place: "/images/keyword/15.jpg",
        text: "Mumbai Airport To Pune Cab",
        link: "/Mumbai-Airport-To-Pune-Cab",
    },
    {
        place: "/images/keyword/16.jpg",
        text: "Kolhapur To Pune Cab",
        link: "/Kolhapur-To-Pune-Cab",
    },
    {
        place: "/images/keyword/17.jpg",
        text: "Kolhapur To Mumbai Cab",
        link: "/Kolhapur-To-Mumbai-Cab",
    },
    {
        place: "/images/keyword/18.jpg",
        text: "Sangli To Pune Cab",
        link: "/Sangli-To-Pune-Cab",
    },
    {
        place: "/images/keyword/19.jpg",
        text: "One Way Taxi in Pune",
        link: "/One-Way-Taxi-in-Pune",
    },
    {
        place: "/images/keyword/20.jpg",
        text: "Best Cab service in Pune",
        link: "/Best-Cab-Service-in-Pune",
    },
    {
        place: "/images/keyword/21.jpg",
        text: "Outstation Cabs Pune",
        link: "/Outstation-Cabs-Pune",
    },
    {
        place: "/images/keyword/22.jpg",
        text: "Swift Dzire Hire in Pune",
        link: "/Swift-Dzire-Hire-in-Pune",
    },
    {
        place: "/images/keyword/23.jpg",
        text: "Xcent Hyundai On Rent in Pune",
        link: "/Xcent-Hyundai-On-Rent-in-Pune",
    },
    {
        place: "/images/keyword/24.jpg",
        text: "Nexa Ciaz On Rent in Pune",
        link: "/Nexa-Ciaz-On-Rent-in-Pune",
    },
    {
        place: "/images/keyword/25.jpg",
        text: "Honda City On Rent In Pune",
        link: "/Honda-City-On-Rent-In-Pune",
    },
    {
        place: "/images/keyword/26.jpg",
        text: "Ertiga On Rent in Pune",
        link: "/Ertiga-On-Rent-in-Pune",
    },
    {
        place: "/images/keyword/27.jpg",
        text: "Innova Cab for Outstation in Pune",
        link: "/Innova-Cab-for-Outstation-in-Pune",
    },
];

  
const images = [
    { src: "/images/ourfleet/1.webp", alt: "Image 1" },
    { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

];


const schemaData = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "SHREE Tours & Travels",
  "description": "Rent a Hyundai Xcent in Pune for affordable and comfortable travel. We offer Xcent Hyundai car rentals for local travel, outstation trips, airport transfers, family travel, group travel, corporate events and more. Call +91 9594917913 to book!",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Your office address here",
    "addressLocality": "Pune",
    "addressRegion": "Maharashtra",
    "postalCode": "411001",
    "addressCountry": "IN"
  },
  "telephone": "+91-9594917913",
  "url": "https://shreetoursandtravels.in",
  "logo": "https://shreetoursandtravels.in/img/logo.jpg",
  "image": [
    "https://shreetoursandtravels.in/img/xcent-hyundai-rental.jpg",
    "https://shreetoursandtravels.in/img/xcent-hyundai-outstation.jpg"
  ],
  "priceRange": "₹1800 - ₹4000",
  "offers": {
    "@type": "Offer",
    "url": "https://shreetoursandtravels.in/xcent-hyundai-hire-pune",
    "priceCurrency": "INR",
    "price": 2500,
    "priceValidUntil": "2025-12-31"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": 4.6,
    "reviewCount": 900
  },
  "review": [
    {
      "@type": "Review",
      "author": {
        "@type": "Person",
        "name": "Rohit Patil"
      },
      "datePublished": "2024-10-10",
      "reviewBody": "The Hyundai Xcent was perfect for our family trip to Mahabaleshwar. It was spacious, comfortable and clean. The driver was professional and the rental service was seamless. Highly recommended!"
    },
    {
      "@type": "Review",
      "author": {
        "@type": "Person",
        "name": "Sangeeta Deshmukh"
      },
      "datePublished": "2024-11-05",
      "reviewBody": "Great experience with SHREE Tours & Travels! The Hyundai Xcent was ideal for our group travel from Pune to Mumbai. The booking process was easy and the car was in excellent condition."
    }
  ],
  "serviceArea": {
    "@type": "Place",
    "name": "Hyundai Xcent Hire Service in Pune",
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 18.5204,  // Pune latitude
      "longitude": 73.8567  // Pune longitude
    }
  },
  "availableChannel": {
    "@type": "ServiceChannel",
    "serviceUrl": "https://shreetoursandtravels.in/xcent-hyundai-hire-pune"
  },
  "keywords": "Xcent Hyundai Car Rental Pune, Rent Hyundai Xcent in Pune, Affordable Xcent Hyundai Rental Pune, Hyundai Xcent Taxi Hire Pune, Xcent for Outstation Travel in Pune, Xcent Hyundai Car Hire for City Tour, Xcent on Rent for Airport Drop Pune, Hyundai Xcent for Family Travel Pune, Book Xcent Hyundai for Business Travel, Hyundai Xcent Rental for Group Travel, Rent Xcent Hyundai for Local Pune Travel, Xcent Hyundai Hire for Corporate Events Pune"
};


  return (
    <div>
    <GoogleAnalytics/>
<Helmet>
  <title>Hyundai Xcent Hire in Pune | SHREE Tours & Travels | Call: +91 9594917913</title>
  <meta name="description" content="Rent a Hyundai Xcent in Pune for affordable and comfortable travel. We offer Xcent Hyundai car rentals for local travel, outstation trips, airport transfers, family travel, group travel, corporate events and more. Call +91 9594917913 to book!" />
  <meta name="keywords" content="Xcent Hyundai Car Rental Pune, Rent Hyundai Xcent in Pune, Affordable Xcent Hyundai Rental Pune, Hyundai Xcent Taxi Hire Pune, Xcent for Outstation Travel in Pune, Xcent Hyundai Car Hire for City Tour, Xcent on Rent for Airport Drop Pune, Hyundai Xcent for Family Travel Pune, Book Xcent Hyundai for Business Travel, Hyundai Xcent Rental for Group Travel, Rent Xcent Hyundai for Local Pune Travel, Xcent Hyundai Hire for Corporate Events Pune" />
  <meta name="robots" content="index, follow" />
  <script type="application/ld+json">
    {JSON.stringify(schemaData)}
  </script>
</Helmet>

    <section
        className="page-title"
        style={{ backgroundImage: 'url(images/hero.jpg)' }}
      >
        <div className="auto-container">
          <div className="title-outer text-center">
            <h1 className="title">{cardData.keyword} </h1>
          </div>
        </div>
      </section>


      <section>
        <div className="container-fluid" >
         <div className="row container-fluid pt-5">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/23.jpg' alt='img' />
              <h3 className="py-1 pt-4"
                style={{
                  color: '#0310a8', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3>

              <div className='pb-3'>
                <button
                  className="p-3 text-white fw-bold borderrr bg-header"
                  onClick={() => {
                    window.location.href = '/booking';
                  }}
                >
                  Book Your Cab
                </button>
              </div>
              <p className='fw-bold lead text-dark'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 text-dark'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
            <BusRatesTable />

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>
              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for SHREE Tours & Travels </h3>
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
                {/* <CustomCarousel items={carouselItems} options={carouselOptions} /> */}

                <TestimonialKeyword testimonials={testimonialsData} />

                
              </div>

              <div className='pb-5'>

                <div className="contact-box Borderr ">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details ">
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold d-inline "><p className='d-inline'><strong className='darkcolor d-inline'>Mobile No:</strong></p>
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4'>
    {Images.map((e) => {
        return (
            <div className="box1">
                <a href={e.link} className="d-flex justify-content-around align-items-center">
                    <div className="b1">
                        <img src={e.place} alt="img" />
                    </div>
                    <div className="b2">
                        <a href={e.link} className='px-3'>{e.text}</a>
                    </div>
                </a>
            </div>
        );
    })}



              <div className="gallery-container">
                <h2 className="gallery-title darkcolor">Our Fleet</h2>
                <div className="row">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}
               
                </div>
              </div>

             <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px solid #0310a8',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3  fw-bold text-bluee text-center">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3 rounded">
                    <div className="Small_border rounded  text-center  " style={{ backgroundColor: '#0310a8' }}>
                      {/* <div> */}
                      <h4 className=" lead fw-semibold whitt ">Phone Numbers</h4>
                      {/* </div> */}
                      {/*  */}
                      {/* <div className=''> */}
                        <a href="tel:+919594917913" className="d-block  text-white">
                        <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 9594917913
                      </a>
                      {/* </div> */}
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      
                      <div className='rounded' style={{ backgroundColor: '#0310a8' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:booking@shreecabs24.com" className=" text-white d-block">
                        <i className="fas fa-envelope darkcolorrr"></i> booking@shreecabs24.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      
                      <div className='rounded ' style={{ backgroundColor: '#0310a8' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className=" text-white ">
                        <i className="fas fa-map-marker-alt darkcolorrr"></i>  SHREE Tours & Travels<br />
                          Maharashtra Co-Operative Housing Society,
                          Yerawada, Pune, Maharashtra India - 411006
                            
                         
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      </section>






    </div>
  );
}

export default Xcenthyundaionrentinpune;